import { render } from "./priceDisplay.vue?vue&type=template&id=437501ad"
import script from "./priceDisplay.vue?vue&type=script&lang=js"
export * from "./priceDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__